import { useId as e, useState as t } from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { Button as i, ComboBox as a, Dialog as o, DialogTrigger as s, FieldError as c, Form as l, Heading as u, Input as d, Label as f, ListBox as p, ListBoxItem as m, Modal as h, ModalOverlay as g, Popover as _, Select as v, SelectValue as y, Text as b, TextField as x } from "react-aria-components";
import { useFilter as S } from "react-aria";
// src/internal/cx.ts
function C(...e) {
	return e.filter((e) => typeof e == "string" && e !== "").join(" ");
}
var w = { alert: "_alert_k2ygd_1" }, T = {
	info: "status",
	success: "status",
	error: "alert",
	emergency: "alert"
};
function E({ tone: e = "info", children: t }) {
	return /* @__PURE__ */ n("div", {
		className: C(w.alert),
		"data-tone": e,
		role: T[e],
		children: t
	});
}
var D = { badge: "_badge_1ghhk_1" };
// src/primitives/Badge.tsx
function O({ tone: e = "neutral", children: t }) {
	return /* @__PURE__ */ n("span", {
		className: C(D.badge),
		"data-tone": e,
		children: t
	});
}
var k = {
	button: "_button_u46b4_1",
	primary: "_primary_u46b4_33",
	secondary: "_secondary_u46b4_39",
	danger: "_danger_u46b4_43",
	label: "_label_u46b4_49",
	pending: "_pending_u46b4_53",
	spinner: "_spinner_u46b4_61",
	spin: "_spin_u46b4_61"
};
// src/primitives/Button.tsx
function A({ variant: e = "secondary", isPending: t = !1, pendingLabel: a, isDisabled: o = !1, isExpanded: s, type: c = "button", onPress: l, children: u }) {
	return /* @__PURE__ */ r(i, {
		className: C(k.button, k[e]),
		type: c,
		isDisabled: o,
		isPending: t,
		...s === void 0 ? {} : { "aria-expanded": s },
		...l ? { onPress: l } : {},
		children: [/* @__PURE__ */ n("span", {
			className: C(k.label),
			children: u
		}), t && a !== void 0 ? /* @__PURE__ */ r("span", {
			className: C(k.pending),
			"aria-live": "polite",
			children: [/* @__PURE__ */ n("span", {
				className: C(k.spinner),
				"aria-hidden": "true"
			}), a]
		}) : null]
	});
}
var j = { error: "_error_1ie2j_3" };
// src/primitives/FieldError.tsx
function M({ id: e, message: t }) {
	return t == null ? null : /* @__PURE__ */ n("p", {
		id: e,
		className: C(j.error),
		role: "alert",
		children: t
	});
}
function N(e, t) {
	return e == null ? {} : {
		"aria-invalid": !0,
		"aria-describedby": t
	};
}
var P = {
	field: "_field_earvq_1",
	label: "_label_earvq_8",
	required: "_required_earvq_14",
	description: "_description_earvq_19",
	error: "_error_earvq_24"
};
// src/primitives/Field.tsx
function F({ label: e, description: t, errorMessage: i, isRequired: a = !1, children: o }) {
	return /* @__PURE__ */ r("div", {
		className: C(P.field),
		children: [
			/* @__PURE__ */ r(f, {
				className: C(P.label),
				children: [e, a ? /* @__PURE__ */ n("span", {
					className: C(P.required),
					"aria-hidden": "true",
					children: "*"
				}) : null]
			}),
			o,
			t === void 0 ? null : /* @__PURE__ */ n(b, {
				slot: "description",
				className: C(P.description),
				children: t
			}),
			i === void 0 ? null : /* @__PURE__ */ n(c, {
				className: C(P.error),
				children: i
			})
		]
	});
}
var I = {
	wrapper: "_wrapper_1ya9r_1",
	input: "_input_1ya9r_6"
};
// src/primitives/TextInput.tsx
function ee({ label: e, description: t, errorMessage: r, isRequired: i = !1, isDisabled: a = !1, type: o = "text", value: s, defaultValue: c, onChange: l, placeholder: u, name: f, autoComplete: p }) {
	return /* @__PURE__ */ n(x, {
		className: C(I.wrapper),
		type: o,
		isInvalid: r !== void 0,
		isRequired: i,
		isDisabled: a,
		...s === void 0 ? {} : { value: s },
		...c === void 0 ? {} : { defaultValue: c },
		...l ? { onChange: l } : {},
		...f === void 0 ? {} : { name: f },
		children: /* @__PURE__ */ n(F, {
			label: e,
			isRequired: i,
			...t === void 0 ? {} : { description: t },
			...r === void 0 ? {} : { errorMessage: r },
			children: /* @__PURE__ */ n(d, {
				className: C(I.input),
				...u === void 0 ? {} : { placeholder: u },
				...p === void 0 ? {} : { autoComplete: p }
			})
		})
	});
}
var L = {
	wrapper: "_wrapper_1kwlb_1",
	trigger: "_trigger_1kwlb_6",
	value: "_value_1kwlb_37",
	popover: "_popover_1kwlb_41",
	listbox: "_listbox_1kwlb_49",
	option: "_option_1kwlb_57"
};
// src/primitives/Select.tsx
function R({ label: e, options: t, description: a, errorMessage: o, isRequired: s = !1, isDisabled: c = !1, placeholder: l, name: u, selectedKey: d, defaultSelectedKey: f, onSelectionChange: h }) {
	return /* @__PURE__ */ r(v, {
		className: C(L.wrapper),
		isInvalid: o !== void 0,
		isRequired: s,
		isDisabled: c,
		...l === void 0 ? {} : { placeholder: l },
		...u === void 0 ? {} : { name: u },
		...d === void 0 ? {} : { selectedKey: d },
		...f === void 0 ? {} : { defaultSelectedKey: f },
		...h ? { onSelectionChange: (e) => h(e === null ? null : String(e)) } : {},
		children: [/* @__PURE__ */ n(F, {
			label: e,
			isRequired: s,
			...a === void 0 ? {} : { description: a },
			...o === void 0 ? {} : { errorMessage: o },
			children: /* @__PURE__ */ r(i, {
				className: C(L.trigger),
				children: [/* @__PURE__ */ n(y, { className: C(L.value) }), /* @__PURE__ */ n("span", {
					className: C(L.arrow),
					"aria-hidden": "true",
					children: "▾"
				})]
			})
		}), /* @__PURE__ */ n(_, {
			className: C(L.popover),
			children: /* @__PURE__ */ n(p, {
				className: C(L.listbox),
				items: t,
				children: (e) => /* @__PURE__ */ n(m, {
					id: e.id,
					className: C(L.option),
					isDisabled: e.isDisabled ?? !1,
					children: e.label
				})
			})
		})]
	});
}
var z = {
	wrapper: "_wrapper_1umvv_1",
	control: "_control_1umvv_6",
	input: "_input_1umvv_15",
	trigger: "_trigger_1umvv_39",
	popover: "_popover_1umvv_49",
	listbox: "_listbox_1umvv_57",
	option: "_option_1umvv_65",
	empty: "_empty_1umvv_85"
};
// src/primitives/Combobox.tsx
function B({ label: e, options: o, description: s, errorMessage: c, isRequired: l = !1, isDisabled: u = !1, placeholder: f, name: h, selectedKey: g, defaultSelectedKey: v, onSelectionChange: y, isLoading: b = !1, loadingLabel: x = "Cargando…", emptyLabel: w = "Sin resultados", suggestionsLabel: T = "Mostrar sugerencias", allowsCustomValue: E = !1, inputValue: D, onInputChange: O }) {
	let { contains: k } = S({ sensitivity: "base" }), [A, j] = t(""), M = D ?? A;
	function N(e) {
		j(e), O?.(e);
	}
	let P = b ? [] : o.filter((e) => k(e.label, M));
	return /* @__PURE__ */ r(a, {
		className: C(z.wrapper),
		items: P,
		isInvalid: c !== void 0,
		isRequired: l,
		isDisabled: u,
		allowsCustomValue: E,
		allowsEmptyCollection: !0,
		...h === void 0 ? {} : { name: h },
		...g === void 0 ? {} : { selectedKey: g },
		...v === void 0 ? {} : { defaultSelectedKey: v },
		...D === void 0 ? {} : { inputValue: D },
		onInputChange: N,
		...y ? { onSelectionChange: (e) => y(e === null ? null : String(e)) } : {},
		children: [/* @__PURE__ */ n(F, {
			label: e,
			isRequired: l,
			...s === void 0 ? {} : { description: s },
			...c === void 0 ? {} : { errorMessage: c },
			children: /* @__PURE__ */ r("div", {
				className: C(z.control),
				children: [/* @__PURE__ */ n(d, {
					className: C(z.input),
					...f === void 0 ? {} : { placeholder: f }
				}), /* @__PURE__ */ n(i, {
					className: C(z.trigger),
					"aria-label": T,
					children: /* @__PURE__ */ n("span", {
						"aria-hidden": "true",
						children: "▾"
					})
				})]
			})
		}), /* @__PURE__ */ n(_, {
			className: C(z.popover),
			children: /* @__PURE__ */ n(p, {
				className: C(z.listbox),
				renderEmptyState: () => /* @__PURE__ */ n("p", {
					className: C(z.empty),
					"aria-live": "polite",
					children: b ? x : w
				}),
				children: (e) => /* @__PURE__ */ n(m, {
					id: e.id,
					className: C(z.option),
					isDisabled: e.isDisabled ?? !1,
					children: e.label
				})
			})
		})]
	});
}
var V = {
	overlay: "_overlay_24wva_1",
	modal: "_modal_24wva_18",
	dialog: "_dialog_24wva_23",
	title: "_title_24wva_44",
	body: "_body_24wva_50",
	footer: "_footer_24wva_54"
};
// src/primitives/Dialog.tsx
function te({ title: e, children: t, footer: i, trigger: a, isOpen: c, onOpenChange: l, isDismissable: d = !0 }) {
	let f = /* @__PURE__ */ n(g, {
		className: C(V.overlay),
		isDismissable: d,
		...c === void 0 ? {} : { isOpen: c },
		...a === void 0 && l ? { onOpenChange: l } : {},
		children: /* @__PURE__ */ n(h, {
			className: C(V.modal),
			children: /* @__PURE__ */ r(o, {
				className: C(V.dialog),
				children: [
					/* @__PURE__ */ n(u, {
						slot: "title",
						className: C(V.title),
						children: e
					}),
					/* @__PURE__ */ n("div", {
						className: C(V.body),
						children: t
					}),
					i === void 0 ? null : /* @__PURE__ */ n("div", {
						className: C(V.footer),
						children: i
					})
				]
			})
		})
	});
	return a === void 0 ? f : /* @__PURE__ */ r(s, {
		...l ? { onOpenChange: l } : {},
		children: [a, f]
	});
}
var H = {
	popover: "_popover_bbkhn_1",
	dialog: "_dialog_bbkhn_9"
};
// src/primitives/Popover.tsx
function ne({ trigger: e, children: t, placement: i = "bottom", "aria-label": a, isOpen: c, onOpenChange: l }) {
	return /* @__PURE__ */ r(s, {
		...c === void 0 ? {} : { isOpen: c },
		...l ? { onOpenChange: l } : {},
		children: [e, /* @__PURE__ */ n(_, {
			className: C(H.popover),
			placement: i,
			children: /* @__PURE__ */ n(o, {
				className: C(H.dialog),
				"aria-label": a,
				children: t
			})
		})]
	});
}
var U = {
	rating: "_rating_ywsk0_3",
	stars: "_stars_ywsk0_9",
	"stars-base": "_stars-base_ywsk0_17",
	"stars-fill": "_stars-fill_ywsk0_22"
};
// src/primitives/Rating.tsx
function re() {
	return /* @__PURE__ */ n("svg", {
		viewBox: "0 0 16 16",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		focusable: "false",
		children: /* @__PURE__ */ n("path", { d: "M8 1.2l2.02 4.1 4.52.66-3.27 3.19.77 4.5L8 11.52l-4.04 2.13.77-4.5L3.46 5.96l4.52-.66z" })
	});
}
function ie({ average: e, text: t }) {
	if (e === null) return /* @__PURE__ */ n("span", {
		className: C(U.rating),
		children: t
	});
	let i = Math.max(0, Math.min(100, e / 5 * 100)), a = Array.from({ length: 5 }, (e, t) => /* @__PURE__ */ n(re, {}, t));
	return /* @__PURE__ */ r("span", {
		className: C(U.rating),
		children: [/* @__PURE__ */ r("span", {
			className: C(U.stars),
			"aria-hidden": "true",
			children: [/* @__PURE__ */ n("span", {
				className: C(U["stars-base"]),
				children: a
			}), /* @__PURE__ */ n("span", {
				className: C(U["stars-fill"]),
				"data-fill": "",
				style: { width: `${i}%` },
				children: a
			})]
		}), /* @__PURE__ */ n("span", {
			className: C(U.text),
			children: t
		})]
	});
}
var W = {
	wall: "_wall_14c4w_1",
	title: "_title_14c4w_14",
	description: "_description_14c4w_21",
	action: "_action_14c4w_29"
}, ae = "Esta parte todavía no está disponible.";
function oe({ title: t, description: i, headingLevel: a = 2, action: o }) {
	let s = e(), c = `h${String(a)}`;
	return /* @__PURE__ */ r("section", {
		className: C(W.wall),
		"aria-labelledby": s,
		children: [
			/* @__PURE__ */ n(c, {
				id: s,
				className: C(W.title),
				children: t
			}),
			/* @__PURE__ */ n("p", {
				className: C(W.description),
				children: i ?? ae
			}),
			o === void 0 ? null : /* @__PURE__ */ n("a", {
				className: C(W.action),
				href: o.href,
				children: o.label
			})
		]
	});
}
var G = {
	card: "_card_p705h_1",
	linked: "_linked_p705h_18",
	eyebrow: "_eyebrow_p705h_26",
	title: "_title_p705h_33",
	description: "_description_p705h_41",
	link: "_link_p705h_18"
};
// src/patterns/card/Card.tsx
function se({ headingLevel: e = 3, title: t, eyebrow: i, description: a, renderLink: o, children: s }) {
	let c = `h${e}`;
	return /* @__PURE__ */ r("div", {
		className: C(G.card, o ? G.linked : void 0),
		children: [
			i === void 0 ? null : /* @__PURE__ */ n("p", {
				className: C(G.eyebrow),
				children: i
			}),
			/* @__PURE__ */ n(c, {
				className: C(G.title),
				children: o ? o({
					className: G.link ?? "",
					children: t
				}) : t
			}),
			a === void 0 ? null : /* @__PURE__ */ n("p", {
				className: C(G.description),
				children: a
			}),
			s
		]
	});
}
var K = {
	empty: "_empty_k9dcu_1",
	title: "_title_k9dcu_12",
	description: "_description_k9dcu_18",
	action: "_action_k9dcu_24"
};
// src/patterns/results/EmptyState.tsx
function ce({ title: e, description: t, action: i, children: a }) {
	return /* @__PURE__ */ r("div", {
		className: C(K.empty),
		children: [
			/* @__PURE__ */ n("h2", {
				className: C(K.title),
				children: e
			}),
			t === void 0 ? null : /* @__PURE__ */ n("p", {
				className: C(K.description),
				children: t
			}),
			a,
			i === void 0 ? null : /* @__PURE__ */ n("p", {
				className: C(K.action),
				children: /* @__PURE__ */ n(A, {
					variant: "primary",
					onPress: i.onPress,
					children: i.label
				})
			})
		]
	});
}
var q = {
	pagination: "_pagination_1ewpw_1",
	next: "_next_1ewpw_7"
};
// src/patterns/results/Pagination.tsx
function le({ hasMore: e, label: t, nextLabel: r, renderNext: i }) {
	return !e || i === void 0 ? null : /* @__PURE__ */ n("nav", {
		className: C(q.pagination),
		"aria-label": t,
		children: i({
			className: q.next ?? "",
			children: r
		})
	});
}
var J = {
	row: "_row_1a733_1",
	linked: "_linked_1a733_16",
	main: "_main_1a733_22",
	title: "_title_1a733_31",
	link: "_link_1a733_16",
	meta: "_meta_1a733_60",
	detail: "_detail_1a733_61",
	badges: "_badges_1a733_75",
	badge: "_badge_1a733_75"
};
// src/patterns/results/ResultRow.tsx
function ue({ headingLevel: e = 3, title: t, meta: i, badges: a = [], detail: o, renderLink: s, children: c }) {
	let l = `h${e}`;
	return /* @__PURE__ */ r("div", {
		className: C(J.row, s ? J.linked : void 0),
		children: [
			/* @__PURE__ */ r("div", {
				className: C(J.main),
				children: [
					/* @__PURE__ */ n(l, {
						className: C(J.title),
						children: s ? s({
							className: J.link ?? "",
							children: t
						}) : t
					}),
					i.length === 0 ? null : /* @__PURE__ */ n("p", {
						className: C(J.meta),
						children: i.map((e, t) => /* @__PURE__ */ r("span", { children: [t > 0 ? /* @__PURE__ */ n("span", {
							"aria-hidden": "true",
							children: " · "
						}) : null, e] }, t))
					}),
					a.length === 0 ? null : /* @__PURE__ */ n("p", {
						className: C(J.badges),
						children: a.map((e, t) => /* @__PURE__ */ n("span", {
							className: C(J.badge),
							children: e
						}, t))
					})
				]
			}),
			o === void 0 ? null : /* @__PURE__ */ n("p", {
				className: C(J.detail),
				children: o
			}),
			c
		]
	});
}
// src/patterns/search/schema.ts
function Y(e, t) {
	return t === "filters" ? [...e.fields, ...e.renderings.filters.extra] : [...e.fields];
}
function X(e) {
	return e.fields.find((t) => t.name === e.renderings.header.collapseTo) ?? e.fields[0];
}
function Z(e, t) {
	return e.kind === "place" && e.allowsCustomValue === !0 ? t.length > 0 : e.options.some((e) => e.id === t);
}
// src/patterns/search/query.ts
function Q(e) {
	return Y(e, "filters");
}
function de(e, t) {
	let n = {};
	for (let r of Q(e)) {
		let e = t[r.name];
		if (e == null) continue;
		let i = e.trim();
		i !== "" && (n[r.name] = i);
	}
	return n;
}
function fe(e) {
	return new URLSearchParams(Object.entries(e)).toString();
}
function pe(e, t) {
	let n = typeof t == "string" ? new URLSearchParams(t.replace(/^\?/, "")) : t, r = {};
	for (let t of Q(e)) {
		let e = n.get(t.name);
		if (e === null) continue;
		let i = e.trim();
		i !== "" && Z(t, i) && (r[t.name] = i);
	}
	return r;
}
function me(e, t) {
	return Q(e).filter((e) => e.isRequired === !0).filter((e) => (t[e.name] ?? "") === "").map((e) => e.name);
}
var $ = {
	form: "_form_1xurl_9",
	fields: "_fields_1xurl_17",
	actions: "_actions_1xurl_30",
	hero: "_hero_1xurl_38",
	header: "_header_1xurl_47",
	filters: "_filters_1xurl_60"
};
// src/patterns/search/SearchBar.tsx
function he({ schema: e, rendering: i, label: a, submitLabel: o, expandLabel: s, values: c, defaultValues: u, onValuesChange: d, onSubmit: f, isPending: p = !1, pendingLabel: m, errors: h }) {
	let [g, _] = t(u ?? {}), [v, y] = t(!1), b = c ?? g;
	function x(e, t) {
		let n = {
			...b,
			[e]: t
		};
		_(n), d?.(n);
	}
	let S = i === "header" && !v, w = X(e), T = S ? w === void 0 ? [] : [w] : Y(e, i);
	function E(e) {
		let t = b[e.name] ?? null, r = h?.[e.name], i = {
			label: e.label,
			options: e.options,
			name: e.name,
			isRequired: e.isRequired ?? !1,
			...e.placeholder === void 0 ? {} : { placeholder: e.placeholder },
			...e.description === void 0 ? {} : { description: e.description },
			...r === void 0 ? {} : { errorMessage: r }
		};
		if (e.kind === "choice") return /* @__PURE__ */ n(R, {
			...i,
			selectedKey: t,
			onSelectionChange: (t) => x(e.name, t)
		}, e.name);
		let a = {
			...e.isLoading === void 0 ? {} : { isLoading: e.isLoading },
			...e.loadingLabel === void 0 ? {} : { loadingLabel: e.loadingLabel },
			...e.emptyLabel === void 0 ? {} : { emptyLabel: e.emptyLabel }
		};
		return e.kind === "place" && e.allowsCustomValue === !0 ? /* @__PURE__ */ n(B, {
			...i,
			...a,
			allowsCustomValue: !0,
			inputValue: t ?? "",
			onInputChange: (t) => x(e.name, t === "" ? null : t)
		}, e.name) : /* @__PURE__ */ n(B, {
			...i,
			...a,
			selectedKey: t,
			onSelectionChange: (t) => x(e.name, t)
		}, e.name);
	}
	return /* @__PURE__ */ r(l, {
		role: "search",
		"aria-label": a,
		validationBehavior: "aria",
		className: C($.form, $[i]),
		onSubmit: (t) => {
			t.preventDefault(), f?.(de(e, b));
		},
		children: [/* @__PURE__ */ n("div", {
			className: C($.fields),
			children: T.map(E)
		}), /* @__PURE__ */ r("div", {
			className: C($.actions),
			children: [i === "header" && s !== void 0 ? /* @__PURE__ */ n(A, {
				isExpanded: v,
				onPress: () => y(!v),
				children: s
			}) : null, /* @__PURE__ */ n(A, {
				type: "submit",
				variant: i === "filters" ? "secondary" : "primary",
				isPending: p,
				...m === void 0 ? {} : { pendingLabel: m },
				children: o
			})]
		})]
	});
}
export { E as Alert, oe as AuthWall, O as Badge, A as Button, se as Card, B as Combobox, te as Dialog, ce as EmptyState, M as FieldError, le as Pagination, ne as Popover, ie as Rating, ue as ResultRow, he as SearchBar, R as Select, ee as TextInput, Z as accepts, X as collapsedField, Y as fieldsFor, N as invalidProps, me as missingRequiredFields, pe as parseSearchQuery, fe as serializeSearchQuery, de as toSearchQuery };

//# sourceMappingURL=index.js.map